import React, { forwardRef, useRef } from "react";
import makeStyles from '@mui/styles/makeStyles';
import swal from "sweetalert";
import { Grid, Checkbox } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as api from "../../../actions/api";

// react-tabulator
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit, ViewList } from "@mui/icons-material";
import encryptionService from "../../../services/encryptionService";

const Role = (props) => {
  const permissionType = props.permissionType;
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "role-entry";
  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

  const classes = useStyles();
  const tableRef = useRef();
  const { useState } = React;
  const [dataItems, setDataItems] = useState([]);
  const { t, i18n } = useTranslation();
  const queryClient = useQueryClient();
  const { isLoading, error, isError, data, refetch } = useQuery(["role"],
    api.getRole,
    {
      onSuccess: (data) => {
        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  const { mutate: deleteApi } = useMutation(api.deleteRole, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
        refetch();
        queryClient.getQueriesData("roles");
        // swal(data.data.message, "", "success");
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  /* =====Start of Excel Export Code==== */
  const EXCEL_EXPORT_URL = process.env.REACT_APP_API_URL;

  const PrintPDFExcelExportFunction = (reportType) => {
    let finalUrl = EXCEL_EXPORT_URL + "report/print_pdf_excel_server.php";

    window.open(
      finalUrl +
        "?action=RoleExport" +
        "&reportType=" +
        reportType +
        "&menukey=" +
        menukey +
        "&lan=" +
        localStorage.getItem("LangCode") +
        "&TimeStamp=" +
        Date.now()
    );
  };
  /* =====End of Excel Export Code==== */


  
  function RowInputData(props: any, type = null) {
    const rowData = props.cell._cell.row.data;
    let fieldName = props.field;
    let fieldType = props.fieldType;
    let labelName = props.labelName;
    let dropDownKey = props.dropDownKey;

    switch (fieldType) {
      case "check-box":
        return rowData.type == "bKeyItem" ? (
          <></>
        ) : (
          <Checkbox
            color="primary"
            checked={!!rowData[fieldName]}
            name={fieldName}
            value={rowData[fieldName] ?? ""}
          />
        );
        break;

      default:
        return <></>;
        break;
    }
    return <></>;
  }


  const tableRowDoubleClick = (e, row) => {
    let rowData = row._row.data;
    editRole(rowData);
  };

  const columns = [
    { title: "Id", field: "id", width: 50, visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#."]),
      formatter: "rownum",
      width: 80,
      hozAlign: "center",
      headerSort: false,
      headerHozAlign: "center",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Role Name"]),
      headerFilter: true,
      width: 300,
      field: "role",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Default Redirect"]),
      headerFilter: true,
      field: "defaultredirect",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Group"]),
      headerFilter: true,
      field: "GroupName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Is Active"]),
      field: "bFacilitySelected",
      hozAlign: "center",
      vertAlign: "middle",
      headerHozAlign: "center",
      width: 90,
      headerSort: true,
      formatter: reactFormatter(
        <RowInputData
          labelName="bFacilitySelected"
          field="bFacilitySelected"
          fieldType="check-box"
        />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Allow all Facility Data Entry"]),
      field: "IsAllFacility",
      hozAlign: "center",
      vertAlign: "middle",
      headerHozAlign: "center",
      width: 90,
      headerSort: true,
      formatter: reactFormatter(
        <RowInputData
          labelName="IsAllFacility"
          field="IsAllFacility"
          fieldType="check-box"
        />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Is Allow Order Complete"]),
      field: "IsAllowOrderComplete",
      hozAlign: "center",
      vertAlign: "middle",
      headerHozAlign: "center",
      width: 90,
      headerSort: true,
      formatter: reactFormatter(
        <RowInputData
          labelName="IsAllowOrderComplete"
          field="IsAllowOrderComplete"
          fieldType="check-box"
        />
      ),
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Actions"]),
      field: "custom",
      hozAlign: "center",
      width: 125,
      headerSort: false,
      headerHozAlign: "center",
      formatter: reactFormatter(<ActionButton />),
    },
  ];

  const editRole = (data) => {
    let route = `role-entry/edit/${data.id}`;
    props.history.push(route);
  };

  const deleteRole = (data) => {
    swal({
      title: t(DispensingLanguage[lan][menukey]["Are you sure?"]),
      text: t(
        DispensingLanguage[lan][menukey][
          "Once deleted, you will not be able to recover this Record!"
        ]
      ),
      icon: "warning",
      buttons: [
        t(DispensingLanguage[lan][menukey]["No"]),
        t(DispensingLanguage[lan][menukey]["Yes"]),
      ],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteApi({
          id: data.id,
          menukey: menukey,
          lan: lan,
          UserName: UserName,
          action: "dataDalete",
        });
      }
    });
  };

  function ActionButton(props) {
    const rowData = props.cell._cell.row.data;
    const cellValue = props.cell._cell.value || "Edit | Show";

    if (rowData.id === 1) {
      if (permissionType) {
        return (
          <>
            <ViewList
              onClick={() => {
                editRole(rowData);
              }}
            />
          </>
        );
      } else {
        return (
          <>
            <Edit
              onClick={() => {
                editRole(rowData);
              }}
            />
          </>
        );
      }
    } else {
      if (!permissionType) {
        return (
          <>
            <Edit
              onClick={() => {
                editRole(rowData);
              }}
            />
            <DeleteOutline
              onClick={() => {
                deleteRole(rowData);
              }}
            />
          </>
        );
      } else {
        return (
          <>
            <ViewList
              onClick={() => {
                editRole(rowData);
              }}
            />
          </>
        );
      }
    }

    /* 
  if(rowData.id==1)
  return (
    <>
      <Edit
        onClick={() => {
          editRole(rowData);
        }}
      />
       
    </>
  );
  else
  return (
    <>
      <Edit
        onClick={() => {
          editRole(rowData);
        }}
      />
      <DeleteOutline
        onClick={() => {
         
          deleteRole(rowData);
        }}
      />
    </>
  ); */
  }

  return (
    <>
      <div className={classes.dispenserPageTitle}>
        <div className="d-flex justify-dispenser mb-2">
          <Grid container>
          <Grid item xs={12} sm={12}>
            <div className="sw_page_heading">
              <div className="sw_heading_title">
                {DispensingLanguage[lan][menukey]["Role Entry"]}
              </div>
              <div className="float-end sw_btn_control">
                <Button
                  disabled={!!props.permissionType}
                  color="info"
                  className="me-2"
                  onClick={() => {
                    props.history.push("/role-entry/add");
                  }}
                >
                  {DispensingLanguage[lan][menukey]["Add Role"]}
                </Button>
                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("print")}
                >
                  <i className="fas fa-print"></i>
                </Button>

                <Button
                  color="info"
                  className="me-2 sw_icons"
                  onClick={() => PrintPDFExcelExportFunction("excel")}
                >
                  <i className="far fa-file-excel"></i>
                </Button>
              </div>
            </div>
          </Grid>
          </Grid>
        </div>

        <div>
          <div className="uniqueName">
            <ReactTabulator
              columns={columns}
              data={dataItems}
              layout={"fitColumns"}
              events={{
                rowDblClick: (e, row) => tableRowDoubleClick(e, row),
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Role;

const useStyles = makeStyles({
  dispenserPageTitle: {
    marginTop: "60px",
    color: "white",
    background: "whitesmoke",
    color: "black",
    borderRadius: "10px",
    padding: "1rem",
  },
  tableContainer: { backgroundColor: "whitesmoke", borderRadius: "10px" },
  fullWidth: {
    width: "95%",
  },
  filterDiv: {
    width: "80%",
    display: "flex",
  },
});
